// Golf 3 (0034_kaart_agenda) in de ouder-webapp: plaatsen zoeken bij "Waar" in de afspraak-editor
// (a.places.*), de reistijd (a.travel.*, Instellingen · Reistijd) en Agenda koppelen (a.feeds.*,
// Instellingen · Agenda koppelen). Je-vorm, kort, rustig (docs/DESIGN.md §2 en §8.KA).
export const appPlacesNl = {
    placeholder: 'Typ een plek, zoals Zwembad De Vliet',
    hintSearch: 'Typ minstens 3 letters: je krijgt voorstellen uit Google Maps.',
    searching: 'Zoeken...',
    suggestions: 'Voorstellen',
    noResults: 'Niets gevonden. Je kunt de plaats ook gewoon typen.',
    /** Naamsvermelding (verplicht bij voorstellen zonder kaart). */
    attribution: 'Voorstellen van Google Maps',
    chosen: 'Gekozen plek',
    change: 'Andere plek',
    remove: 'Plek weghalen',
    /** Alleen tekst, geen gekozen plek. */
    typedOnly: 'Alleen tekst (geen plek op de kaart)',
    notConfigured: 'Zoeken via Google Maps staat op deze server nog niet aan. Typ de plaats gewoon.',
    unavailable: 'Google Maps geeft nu even geen antwoord. Typ de plaats gewoon, of probeer het zo opnieuw.',
    tooMany: 'Even te veel zoekvragen. Probeer het over {minutes} minuten opnieuw.',
    saveFailed: 'De plek is niet bewaard (de afspraak wel). Probeer het zo opnieuw.',
    // Reistijd bij een gekozen plek.
    travelTitle: 'Reistijd',
    travelAuto: '{minutes} min {mode}',
    travelAutoHint: 'Uitgerekend vanaf jullie plaats. Kies je hieronder zelf een reistijd, dan telt die.',
    travelPending: 'Wordt uitgerekend bij opslaan.',
    travelStatus: {
        no_origin: 'Kies eerst de plaats van jullie gezin, dan rekent de app de reistijd uit.',
        no_route: 'Google Maps weet geen route naar deze plek.',
        not_configured: 'Reistijd uitrekenen staat op deze server nog niet aan.',
        unavailable: 'De reistijd lukte even niet. Bij de volgende keer opslaan proberen we het opnieuw.',
        module_off: 'Reistijd staat uit (Instellingen · Modules).',
    },
    modeTitle: 'Hoe gaan jullie?',
    modeUsual: 'Zoals altijd',
    modes: { drive: 'Auto', bicycle: 'Fiets', walk: 'Lopen' },
    /** Na de minuten: "15 min met de auto". */
    modeWith: { drive: 'met de auto', bicycle: 'op de fiets', walk: 'lopen' },
    autoOption: 'Automatisch ({minutes} min)',
    // fix/afspraakformulier: schakelaar bij "Waar" (onthouden op dit apparaat, per gebruiker).
    google: 'Zoeken via Google Maps',
    googleOn: 'Aan: voorstellen via onze server (Google Maps).',
    googleOff: 'Uit: je typt de plek zelf. Er gaat niets naar Google.',
    moduleOff: 'Plaatsen zoeken staat uit (Instellingen · Modules). Typ de plek gewoon.',
};
export const appTravelNl = {
    title: 'Reistijd en plekken',
    intro: 'Kies bij "Waar" een plek uit de voorstellen, dan rekent de app uit hoe lang jullie onderweg zijn. De tablet zegt dan op tijd dat jullie moeten vertrekken.',
    modeTitle: 'Zo reizen we meestal',
    modeHint: 'Per afspraak kun je iets anders kiezen.',
    saved: 'Opgeslagen',
    originMissing: 'Jullie plaats ontbreekt nog. Zonder vertrekpunt geen reistijd.',
    originLink: 'Plaats kiezen',
    googleOff: 'Google Maps staat op deze server nog niet aan: voorstellen en reistijd werken dan niet. Typen bij "Waar" werkt altijd.',
    privacyTitle: 'Wat gaat er naar Google?',
    privacyBody: 'Alleen wat je typt bij "Waar", een grove plek rond jullie woonplaats (ongeveer 5 km) en voor de reistijd het vertrekpunt op ongeveer een kilometer. Nooit namen, e-mailadressen of wie er meegaat. Google rekent voor ons; de tablet en je browser praten nooit met Google.',
    settingsBody: 'Auto, fiets of lopen; wat er naar Google gaat',
};
export const appFeedsNl = {
    title: 'Agenda koppelen',
    settingsBody: 'Jullie afspraken ook in Google, Outlook of op de iPhone',
    intro: 'Zet jullie afspraken ook in Google Agenda, Outlook of op je iPhone. Het bord blijft de plek waar je plant: wat je daar verandert, komt niet terug.',
    oneWay: 'Eén kant op',
    inbound: 'Andersom, een agenda van school of sport binnenhalen? Dat doe je bij Kalenders.',
    inboundLink: 'Naar Kalenders',
    forWho: 'Voor wie',
    lastFetchedNever: 'nog nooit',
    settingsLabel: 'Instellingen van deze link',
    newTitle: 'Nieuwe link',
    whose: 'Welke afspraken?',
    whole: 'Het hele gezin',
    /** "Alleen Yakub" */
    memberOnly: 'Alleen {name}',
    busyOnly: 'Alleen "bezet" tonen',
    busyOnlyHint: 'Anderen zien dat er iets is, niet wat. Handig voor een werkagenda.',
    faith: 'Ook afspraken bij ons geloof (zoals Bidden of Moskeeles)',
    faithHint: 'Staat standaard uit: Google, Microsoft of Apple leest dan mee.',
    create: 'Link maken',
    creating: 'Even geduld...',
    created: 'Je link staat klaar',
    copy: 'Link kopiëren',
    copied: 'Gekopieerd',
    copyFailed: 'Kopiëren lukte niet. Selecteer de link en kopieer hem zelf.',
    openApple: 'Open in Agenda (iPhone, Mac)',
    linkOnce: 'Plak de link nu in je agenda-app. Wij bewaren hem niet leesbaar: later maak je gewoon een nieuwe.',
    linkLabel: 'Jouw link',
    listTitle: 'Jullie links',
    empty: 'Nog geen links. Maak er hierboven een.',
    forWhole: 'Hele gezin',
    forMember: '{name}',
    badgeBusy: 'Alleen bezet',
    badgeFaith: 'Met geloof',
    lastFetched: 'Laatst opgehaald: {when}',
    neverFetched: 'Nog niet opgehaald door een agenda-app',
    hiddenLink: 'De link zelf zie je alleen bij het maken.',
    renew: 'Nieuwe link',
    renewTitle: 'Nieuwe link maken?',
    renewBody: 'De oude link werkt daarna niet meer. Plak de nieuwe link opnieuw in je agenda-app.',
    renewConfirm: 'Nieuwe link maken',
    revoke: 'Intrekken',
    revokeTitle: 'Link intrekken?',
    revokeBody: 'Deze link werkt dan direct niet meer. De afspraken verdwijnen bij de volgende verversing uit de andere agenda.',
    revokeConfirm: 'Intrekken',
    revoked: 'Link ingetrokken',
    cancel: 'Annuleren',
    tooMany: 'Hooguit 20 links per gezin. Trek eerst een oude link in.',
    howTitle: 'Zo zet je hem erin',
    google: {
        title: 'Google Agenda',
        steps: [
            'Open Google Agenda op een computer (calendar.google.com).',
            'Klik links bij "Andere agenda\'s" op het plusje.',
            'Kies "Via URL".',
            'Plak de link en klik op "Agenda toevoegen".',
        ],
    },
    outlook: {
        title: 'Outlook en Microsoft 365',
        steps: [
            'Open Outlook op het web (outlook.office.com of outlook.live.com).',
            'Ga naar Agenda en kies "Agenda toevoegen".',
            'Kies "Abonneren via internet".',
            'Plak de link, geef de agenda een naam en klik op "Importeren".',
        ],
    },
    apple: {
        title: 'iPhone en iCloud',
        steps: [
            'Open Instellingen op je iPhone.',
            'Tik op Apps, dan Agenda, dan Agenda-accounts, dan "Voeg account toe". (Op een oudere iPhone: Agenda, dan Accounts.)',
            'Tik op "Anders" en dan op "Voeg agenda-abonnement toe".',
            'Plak de link en tik op "Volgende" en "Bewaar".',
        ],
    },
    refreshNote: "Eerlijk is eerlijk: Google Agenda haalt zo'n link maar eens in de paar uur op, soms nog minder vaak. Outlook en de iPhone doen het vaker. Een wijziging staat dus niet meteen overal; op het bord wel.",
    privacyNote: 'Privé-afspraken gaan nooit mee. Wie de link heeft, kan de afspraken lezen: deel hem niet verder, en trek hem in als hij ergens rondslingert.',
    /** In de .ics bij "alleen bezet". */
    icsBusy: 'Bezet',
    /** Een bijzondere dag van meer dagen in de .ics. */
    icsDayOf: '{title} (dag {index} van {count})',
};
//# sourceMappingURL=kaartApp.nl.js.map